import React from 'react';
import PropTypes from 'prop-types';
import AuthContext from 'contexts/JWTContext';
import RolePermission from 'utils/permission';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector } from 'store';

const PermissionDisplay = ({ children, action, resource, route = null }) => {
    const navigate = useNavigate();
    const context = React.useContext(AuthContext);
    const { clientSettings } = useSelector((state) => state.settings);
    const { trial = false } = clientSettings;
    const location = useLocation();
    let isAuthorized = false;

    const userRoles = context?.user?.roles || [];
    if (userRoles.length > 0) {
        const rolePermission = new RolePermission(userRoles[0]);
        isAuthorized = rolePermission.isAuthorized(action, resource);
    }

    React.useEffect(() => {
        if (!isAuthorized && route === location.pathname && route !== null) {
            return navigate('/', { replace: true });
        }
    });

    // still show the nav items even if trial
    return isAuthorized || trial ? <>{children}</> : null;
};

PermissionDisplay.propTypes = {
    children: PropTypes.any,
    action: PropTypes.any,
    resource: PropTypes.any,
    route: PropTypes.any,
    permissions: PropTypes.object
};

export default PermissionDisplay;
